module.exports = __webpack_public_path__ + "static/media/rag-flow.a0ce0edb.svg";